import { BoosterType } from 'shared/types';

export const BOOSTERS_ICONS: Record<BoosterType, string> = {
  booster_insects_x: '/boosters/icons/1.webp',
  booster_don_x: '/boosters/icons/2.webp',
  booster_duration_x: '/boosters/icons/3.webp',
  booster_daily_bonus_limit_plus: '/boosters/icons/4.webp',
};
